<template>
  <div class="bundle-slider" v-if="bundlesToShow.length">
    <div class="d-flex justify-center align-center">
      <h1>Pakketilbud</h1>
    </div>
    <v-slide-group show-arrows>
      <v-slide-item v-for="(bundle, i) in bundlesToShow" :key="i" v-slot:default="{ active, toggle }"
        class="mx-2 hover-zoom py-3" style="cursor: pointer">
        <B2CItemCard :style="cardWidth" @clickButton="addBtnAction(bundle)" @clickCard="goToBundle(bundle)"
          :id="bundle.campaignId.toString()" :title="bundle.campaignName" type="P" :imageUrl="bundle.imgUrl"
          :subtitle="getBundleEndTime(bundle.campaignDateTo).time" :price="bundle.totalValue" :stockAmount="bundle.onlineStock"
          :campaignValue="bundle.campaignValue" :campaignText="bundle.additionalValue + '%'"></B2CItemCard>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>
<script>
import imageTypes from "@/constants/image-types";
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import { mapWaitingActions } from "vue-wait";
import B2CItemCard from "@fixit/v-b2c-item/src/B2CItemCard.vue";

export default {
  mixins: [webshopMixins],
  components: {
    B2CItemCard,
  },
  computed: {
    ...mapWaitingActions("campaigns", {
      getCampaingsByFilter: "loading campaigns getCampaingsByFilter",
    }),
    cardWidth() {
      let width = ''
      switch(true) {
        case this.$vuetify.breakpoint.lg:
        case this.$vuetify.breakpoint.xl:
          width = '320px'
          break;
        case this.$vuetify.breakpoint.md:
        case this.$vuetify.breakpoint.sm:
          width = '250px'
          break;
        default:
          width = '164px'
      }
      return `width: ${width}`
    },
    selectedBundleId(){
      return this.selectedBundle?.campaignId || 0
    },
    bundlesToShow() {
      if (this.$route.name === "webshopChain") {
        return this.bundles;
      } else {
        return this.bundles.filter(
          (c) => c.campaignId != this.selectedBundleId
        );
      }
    },
  },
  data() {
    return {
      windowSize: { x: window.innerWidth, y: window.innerHeight },
      imageTypes,
    };
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    getBundleEndTime(time) {
      let end = this.$moment(time);
      let start = this.$moment();
      let duration = this.$moment.duration(end.diff(start));

      if (Math.round(duration.asDays()) > 2) {
        return {
          time: this.$moment(time).format("DD. MMMM YYYY"),
          alert: false,
        };
      } else if (Math.round(duration.asDays()) <= 2) {
        return {
          time:
            Math.round(duration.asDays()) == 1
              ? "1 dag igjen"
              : "2 dager igjen",
          alert: true,
        };
      } else if (Math.round(duration.asDays()) < 1) {
        return {
          time: Math.round(duration.asHours()) + " timer igjen",
          alert: true,
        };
      }
    },
    async openSalonSelectDialog(bundle) {
      this.$store.dispatch("campaigns/set", { key: "bundle", value: bundle });
      this.$store.dispatch("webshop/set", {
        key: "bundleSalonPickOptions",
        value: { dialog: true },
      });
    },
    async addBtnAction(bundle) {
      await this.$store.dispatch("webshop/set", {
        key: "selectedBundle",
        value: bundle,
      });

      // if (this.salons.length === 1) {

      await this.$store.dispatch("campaigns/set", {
        key: "bundle",
        value: bundle,
      });
      this.addBundleToSalonCart(this.salons[0]);
      // } else {
      // this.openSalonSelectDialog(bundle);
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.VueCarousel-slide {
  padding: 10px;
}

.VueCarousel {
  max-width: 100%;
}

.action__buttons::v-deep {
  .v-btn {
    height: 42px !important;
  }
}

.product__description div {
  white-space: pre-wrap;
}

.v-skeleton-loader__heading {
  margin: 0 auto;
}

.product-discount-tag {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #ffffff;
  z-index: 3;
}
</style>
<style lang="scss">
.bundle-slider {
  .v-slide-group {
    .v-slide-group {
      &__wrapper {
        padding: 25px 0;
      }

      &__content {
        justify-content: center !important;
      }
    }
  }
}
</style>
